module.exports = __webpack_public_path__ + "static/media/present.a1254c23.svg";